import React, { FunctionComponent } from 'react'
import { Controller, useFormContext } from 'react-hook-form'

import { InputConfig } from '../../../state/configuration'

interface FormHiddenProps {
  item: InputConfig
  controllerName: string
}

export const FormHidden: FunctionComponent<FormHiddenProps> = ({
  controllerName,
  item: { conditional },
}) => {
  const { control } = useFormContext()

  return (
    <Controller
      name={controllerName}
      control={control}
      shouldUnregister={!conditional?.preserve}
      render={({ field: { value, ...field } }) => (
        <input type='hidden' value={value ?? ''} {...field} />
      )}
    />
  )
}
